import { type ElementType } from "react";
import { styled } from "@mui/material/styles";
import Stack from "@mui/material/Stack";
import Skeleton from "@mui/material/Skeleton";
import { HeadingXS } from "./Typography";

export const SmartActionButton = styled(Stack)<{ component?: ElementType; to?: string }>(({ theme }) =>
    theme.unstable_sx({
        "&&": {
            alignItems: "center",
            justifyContent: "center",
            bgcolor: "primary.main",
            color: "#ffffff",
            borderRadius: 1,
            p: 2,
            flex: 1,
            textDecoration: "none",
            minHeight: { md: 92, xs: 74 },
            textAlign: "center",
            "&:hover": { opacity: 0.9 },
            "&:link, &:visited, &:active": { color: "#ffffff" },
        },
    }),
);

export const SmartActionLabel = styled(HeadingXS)(({ theme }) =>
    theme.unstable_sx({
        "&&": {
            mb: 0,
            fontSize: { md: "1.4rem", xs: "1.2rem" },
            color: "#ffffff",
        },
    }),
);

export const SkeletonContainer = styled(Stack)(({ theme }) =>
    theme.unstable_sx({
        flexDirection: "row",
        justifyContent: "center",
        width: "100%",
    }),
);

export const SkeletonItem = styled(Skeleton)(({ theme }) =>
    theme.unstable_sx({
        width: "33.33%",
        height: { md: 92, xs: 74 },
        bgcolor: "primary.main",
    }),
);

export const SmartActionIcon = styled(Stack)({
    "& svg": { width: "2.4rem", height: "2.4rem", fill: "currentColor", color: "inherit" },
});
